<template>
  <v-card
    class="mx-auto"
  >
    <card-title-bar icon="mdi-history" text="前回と同じ内容で注文"></card-title-bar>

    <v-container>
      <div class="text-subtitle-1 mb-3">注文日: {{ latestOrder.order_date }}</div>
      <template v-for="item in latestOrder.details">
        <div class="text-body-1" :key="`row1-${item.id}`">
          {{ item.merchandise_name }} - {{ item.merchandise_type_name }}
        </div>
        <div class="text-body-1 text-end" :key="`row2-${item.id}`">
          <span class="mr-3">数量:{{item.qty}}</span>    
          <span>{{ item.amount | toPriceFormat }}</span>
        </div>
        <v-divider
          :key="`divider-${item.id}`"
        ></v-divider>
      </template>
      <div class="text-end">
        送料: {{ latestOrder.aggregate.postage_subtotal | toPriceFormat }}
      </div>
      <div class="text-subtitle-1 text-end">
        合計: {{ latestOrder.aggregate.total_amount | toPriceFormat }}
      </div>
      <v-btn 
        color="primary"
        class="text-subtitle-1"
        @click="orderAgain(latestOrder.details)"
      >
        この内容で再注文する
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import CardTitleBar from './parts/CardTitleBar'

export default {
  name: 'ReOrder', 
  components: {
    CardTitleBar,
  },
  props:{
    latestOrder: Object,
  },
  methods: {
    orderAgain(details) {
      this.$emit('order-again-click', details)
    },
  },
}
</script>